import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import formTemplatesService from "../services/form-templates-service";

export const formTemplateSearchQuery = z.object({
	search: z.string().optional(),
	type: z.string(),
	per_page: z.number().optional(),
	page: z.number().nullable().optional(),
});

export const formTemplateQueryOptions = (formTemplateId: string) => {
	return queryOptions({
		queryKey: ["form_templates", formTemplateId],
		queryFn: () => formTemplatesService.findById(formTemplateId),
	});
};

export const formTemplatesQueryOptions = (search?: z.infer<typeof formTemplateSearchQuery>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["form_templates", search],
		queryFn: () => formTemplatesService.list(transformSearch(search, ["type"])),
		...options,
	});
};

export const useFormTemplateMutation = () => {
	return useMutation({
		mutationKey: ["form_templates"],
		mutationFn: formTemplatesService.upsert,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["form_templates"] });
		},
	});
};
